<template>
  <v-card>
    <v-toolbar class="cyan" dark flat>
      <v-text-field
      solo
      clearable
      placeholder="Nach Datensätzen suchen..."
      prepend-icon="search"
      v-model="searchDatasetsMeta"
      ></v-text-field>
    </v-toolbar>
    <v-list two-line style="padding: 0">
      <div class="body-2 grey--text pa-3" v-if="showHint">Wählen Sie einen Datensatz aus, um fortzufahren.</div>
      <v-list-tile v-for="dataset in datasetsMetaFiltered" :key="dataset.name" :to="dataset.id" v-if="dataset.name">
        <v-list-tile-content>
          <v-list-tile-title v-text="dataset.name"></v-list-tile-title>
          <v-list-tile-sub-title v-text="dataset.description"></v-list-tile-sub-title>
        </v-list-tile-content>
        <v-list-tile-action>
          <v-btn icon ripple>
            <v-icon color="grey lighten-1">keyboard_arrow_right</v-icon>
          </v-btn>
        </v-list-tile-action>
      </v-list-tile>
      <v-list-tile v-if="!datasetsMetaFiltered.length">
        <v-list-tile-action>
          <v-icon>error</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>Keine Datensätze gefunden</v-list-tile-title>
          <v-list-tile-sub-title>Es wurde für Ihren Suchbegriff kein Datensatz gefunden.</v-list-tile-sub-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>
  </v-card>
</template>

<script>
export default {
  name: 'searchDatasets',
  computed: {
    datasetsMetaFiltered () {
      return this.datasetsMeta.filter(dataset => {
        if (this.searchDatasetsMeta != null) {
          let result = dataset.name.toLowerCase().includes(this.searchDatasetsMeta.toLowerCase())
          result += dataset.description.toLowerCase().includes(this.searchDatasetsMeta.toLowerCase())
          return result
        }
        return this.datasetsMeta
      })
    },
    currentDataset () {
      return this.$store.getters.getCurrentDataset
    }
  },
  data () {
    return {
      searchDatasetsMeta: null,
      active: true
    }
  },
  methods: {},
  props: ['loading', 'datasetsMeta', 'showHint']
}
</script>

<style>
.file-upload {
  margin-top: 20px;
  min-height: 120px;
  outline: 5px dashed #efefef;
  outline-offset: -5px;
}

.list__tile--active {
  background-color: rgba(0, 0, 0, 0.08) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/SearchDatasets.vue